export default __webpack_public_path__ + "static/media/industrial-rustic-living-room-in-earthy-tones.0af095f9.jpg";